/* LGERU-73 : 20200715 modify */
// LGERU-285 WTB API change START
var BUList = {		
	//기존 Hatch
	/*"dryers":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"ultra-large-televisions":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"video":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"tv-audio-video":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"computer-products":
	{
		online: "52753",
		offline: "5aeaeaea46e0fb0001be2104"
	},
	"mobile":
	{
		online: "52649",
		offline: "5aeaead546e0fb0001be202c"
	},
	"home-appliances":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"smartphones":
	{
		online: "52649",
		offline: "5aeaead546e0fb0001be202c"
	},
	"microwaves":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"monitors":
	{
		online: "52753",
		offline: "5aeaeaea46e0fb0001be2104"
	},
	"refrigerators":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"televisions":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	audio:
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"washing-machines":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"vacuum-cleaners":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"built-in-appliances":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"air-conditioners-split-systems":
	{
		online: "52755",
		offline: "5aeaeae946e0fb0001be20f8"
	},
	"oled-televisions":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"super-uhd-4k-televisions":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"uhd-4k-televisions":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"led-televisions-full-hd":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"home-theaters":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"soundbars":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"minisystems":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"audio-system":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"x-boom-systems":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"blu-ray-players":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"karaoke-system":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"dvd-players":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"bluetooth-speakers":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"ultrawide-monitors":
	{
		online: "52753",
		offline: "5aeaeaea46e0fb0001be2104"
	},
	"ips-screens":
	{
		online: "52753",
		offline: "5aeaeaea46e0fb0001be2104"
	},
	"4k-monitors":
	{
		online: "52753",
		offline: "5aeaeaea46e0fb0001be2104"
	},
	"led-monitors":
	{
		online: "52753",
		offline: "5aeaeaea46e0fb0001be2104"
	},
	"gaming-monitors":
	{
		online: "52753",
		offline: "5aeaeaea46e0fb0001be2104"
	},
	"cloud-monitors":
	{
		online: "52753",
		offline: "5aeaeaea46e0fb0001be2104"
	},
	"hdmi-monitors":
	{
		online: "52753",
		offline: "5aeaeaea46e0fb0001be2104"
	},
	"projectors":
	{
		online: "52749",
		offline: "5aeaeaea46e0fb0001be2100"
	},
	"lg-friends":
	{
		online: "52649",
		offline: "5aeaead546e0fb0001be202c"
	},
	"wearable":
	{
		online: "52649",
		offline: "5aeaead546e0fb0001be202c"
	},
	"mobile-phone-accessories":
	{
		online: "52649",
		offline: "5aeaead546e0fb0001be202c"
	},
	"refrigerators-bottom-freezer":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"refrigerators-top-freezer":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"refrigerators-side-by-side":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"multi-chamber-refrigerators":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"standard-washing-machines":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"washing-machines-twin-wash":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"narrow-washing-machines":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"super-narrow-washing-machines":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"vacuum-cleaners-cordless":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"vc-robots":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"vacuum-cleaners-kompressor":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"vacuum-cleaners-simplebin":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"vacuum-cleaners-bagless":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"vacuum-cleaners-bag":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"solo-microwaves":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"microwaves-with-grill":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"convection-microwaves":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"ovens":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"cooktops":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"built-in-refrigerators":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"built-in-appliances-hoods":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"art-cool-airconditioners":
	{
		online: "52755",
		offline: "5aeaeae946e0fb0001be20f8"
	},
	"silent-airconditioners":
	{
		online: "52755",
		offline: "5aeaeae946e0fb0001be20f8"
	},
	"inverter-airconditioners":
	{
		online: "52755",
		offline: "5aeaeae946e0fb0001be20f8"
	},
	"air-cleaner":
	{
		online: "52755",
		offline: "5aeaeae946e0fb0001be20f8"
	},
	"climatic-systems":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"humidifiers":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"ionizers":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"stylers":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"premium-smartphones":
	{
		online: "52649",
		offline: "5aeaead546e0fb0001be202c"
	},
	"new-smartphones":
	{
		online: "52649",
		offline: "5aeaead546e0fb0001be202c"
	},
	"dual-sim-smartphones":
	{
		online: "52649",
		offline: "5aeaead546e0fb0001be202c"
	},
	"4g-smartphones":
	{
		online: "52649",
		offline: "5aeaead546e0fb0001be202c"
	},
	"air-purifiers-humidifiers":
	{
		online: "52751",
		offline: "5aeaeae946e0fb0001be20fc"
	},
	"etc":
	{
		online: "52649",
		offline: "5aeaead546e0fb0001be202c"
	}*/
	/** 새로운 24WTB 솔루션 **/
	/** LG HE **/
	//LGERU-334 s
	"audio":
	{
		online: "315e2ea7-d792-4faa-bfa9-795b7f21640d",
		offline: "315e2ea7-d792-4faa-bfa9-795b7f21640d"
	},
	"televisions":
	{
		online: "315e2ea7-d792-4faa-bfa9-795b7f21640d",
		offline: "315e2ea7-d792-4faa-bfa9-795b7f21640d"
	},
	"soundbars":
	{
		online: "315e2ea7-d792-4faa-bfa9-795b7f21640d",
		offline: "315e2ea7-d792-4faa-bfa9-795b7f21640d"
	},
	"projectors":
	{
		online: "315e2ea7-d792-4faa-bfa9-795b7f21640d",
		offline: "315e2ea7-d792-4faa-bfa9-795b7f21640d"
	},
	"laptops":
	{
		online: "315e2ea7-d792-4faa-bfa9-795b7f21640d",
		offline: "315e2ea7-d792-4faa-bfa9-795b7f21640d"
	},
	// LGERU-394 Start
	"bluetooth-headphones":
	{
		online: "315e2ea7-d792-4faa-bfa9-795b7f21640d",
		offline: "315e2ea7-d792-4faa-bfa9-795b7f21640d"
	},
	// LGERU-394 End
	/** LG HA **/
	"washing-machines":
	{
		online: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5", // LGERU-394
		offline: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5"
	},
	"microwaves":
	{
		online: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5",
		offline: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5"
	},
	"vacuum-cleaners":
	{
		online: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5",
		offline: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5"
	},
	"built-in-appliances":
	{
		online: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5",
		offline: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5"
	},
	"stylers":
	{
		online: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5",
		offline: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5"
	},
	"refrigerators":
	{
		online: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5",
		offline: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5"
	},
	"dryers":
	{
		online: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5",
		offline: "47dd96cd-074d-4784-93e3-1b1bf4b8d5a5"
	},
	/** LG AC **/
	"air-purifiers-humidifiers":
	{
		online: "986d2401-d808-45a9-884f-8cfb81d68eeb", // LGERU-394
		offline: "986d2401-d808-45a9-884f-8cfb81d68eeb"
	},
	"air-conditioners-split-systems":
	{
		online: "986d2401-d808-45a9-884f-8cfb81d68eeb",
		offline: "986d2401-d808-45a9-884f-8cfb81d68eeb"
	},
	/** LG Monitors **/
	"monitors":
	{
		online: "08185e13-235f-4c78-816a-972584fda6e7",
		offline: "08185e13-235f-4c78-816a-972584fda6e7"
	},
	"etc":
	{
		online: "52649",
		offline: "315e2ea7-d792-4faa-bfa9-795b7f21640d"
	}
	// LGERU-285 WTB API change END
	//LGERU-334 e
},
getBuListCategory = function() {
	var e;
	if ("3000" == location.port) e = "televisions";
	else {
		var a = $('link[rel="canonical"]').eq(0).attr("href").split("/");
		// LGERU-285 WTB API change START
		e = a[a.length - 2].toLowerCase();
		// LGERU-285 WTB API change END
	}
	return e || "etc"
},
getBU = function(e) { return BUList[getBuListCategory()] ? BUList[getBuListCategory()][e] : BUList.etc[e] };
//# sourceMappingURL=maps/get-hatch-bu-ru.min.js.map
/*// LGERU-73 : 20200715 modify */